// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91e3c07c","239":"2661bdbf","455":"2fbc9df7"}[chunkId] + ".chunk.js";
};